var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83 4.5a1 1 0 0 1 1-1h12.5a1 1 0 0 1 1 1v10.83a1 1 0 0 1-1 1H2.83a1 1 0 0 1-1-1V4.5Zm2 1v8.83h10.5V5.5H3.83Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.33 8.67a1 1 0 0 1 1-1h3.34a1 1 0 0 1 .7.29l2.5 2.5a1 1 0 0 1 .3.7v4.17a1 1 0 0 1-1 1h-5.84a1 1 0 0 1-1-1V8.67Zm2 1v4.66h3.84v-2.75l-1.92-1.91h-1.92ZM6.58 16.33a1.08 1.08 0 1 0 0 2.17 1.08 1.08 0 0 0 0-2.17ZM3.5 17.42a3.08 3.08 0 1 1 6.17 0 3.08 3.08 0 0 1-6.17 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.42 16.33a1.08 1.08 0 1 0 0 2.17 1.08 1.08 0 0 0 0-2.17Zm-3.09 1.09a3.08 3.08 0 1 1 6.17 0 3.08 3.08 0 0 1-6.17 0Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.b7b80d5097c044ca17fcf92138497458.svg";
export { ForwardRef as ReactComponent };